<template>
  <div id="rwa_publish_div" class="rwa_publish_div">

    <div class="rwa_publish_page_01">
      <Menu/>
    </div>

    <div id="rwa_publish_page_02" ref="rwa_publish_page_02" class="rwa_publish_page_02">

      <div class="rwa_publish_page_021">
        <img class="rwa_publish_page_021_bj01" src="../../assets/images/Ellipse_bjl.png"/>
        <img class="rwa_publish_page_021_bj03" src="../../assets/images/Ellipse_bjr.png"/>

        <div class="rwa_publish_page_021s">
          <div class="rwa_publish_page_0211" @click="toIndex()">
            <img src="../../assets/images/fhui.png"/>
            <div>首页</div>
          </div>

          <div class="rwa_publish_page_0212s">
            <div class="rwa_publish_page_0212">
              <div class="rwa_publish_info_title">发布拍卖信息</div>

              <div class="rwa_publish_info_01">

                <el-upload
                    class="rwa_publish_info_011"
                    ref="uploadLogo"
                    :action="imgHost +'/api/v1/project/' + addProjectId + '/upload'"
                    :data="uploadLogoFormData"
                    :on-remove="logoHandleRemove"
                    :on-progress="logoHandleProgress"
                    :on-success="logoUploadSuccess"
                    :before-upload="logoUpload"
                    :on-change="logoHandleChange"
                    list-type="picture"
                    :file-list="logoList"
                    :limit="20"
                    :multiple="true"
                    :show-file-list="true"
                    :auto-upload="false"
                    accept="image/jpeg,image/jpg,image/png,image/svg,image/gif"
                    >
                    <img src="../../assets/images/bjia.png" :style="logoList.length > 0 ? 'margin-top: 15px' : ''"/>
                    <div v-if="logoList.length === 0">选择LOGO</div>
                    <div v-if="logoList.length > 0" class="rwa_publish_info_0111_sc" @click.stop="logoSubmitUpload">上传LOGO</div>
                    <div class="rwa_publish_info_0111">jpeg/png/gif(<10MB)</div>
                </el-upload>


                <el-upload
                    class="rwa_publish_info_012"
                    ref="uploadCertificate"
                    :action="imgHost +'/api/v1/project/' + addProjectId + '/upload'"
                    :data="uploadCertificateFormData"
                    :on-remove="certificateHandleRemove"
                    :on-progress="certificateHandleProgress"
                    :on-success="certificateUploadSuccess"
                    :before-upload="certificateUpload"
                    :on-change="certificateHandleChange"
                    list-type="picture"
                    :file-list="certificateList"
                    :limit="20"
                    :show-file-list="true"
                    :auto-upload="false"
                    accept="image/jpeg,image/jpg,image/png,image/svg,image/gif"
                >
                  <img src="../../assets/images/bjia.png" :style="certificateList.length > 0 ? 'margin-top: 15px' : ''"/>
                  <div v-if="certificateList.length === 0">选择证书</div>
                  <div v-if="certificateList.length > 0" class="rwa_publish_info_0121_sc" @click.stop="certificateSubmitUpload">上传证书</div>
                </el-upload>


                <el-upload
                    class="rwa_publish_info_013"
                    ref="uploadVideo"
                    :action="imgHost +'/api/v1/project/' + addProjectId + '/upload'"
                    :data="uploadVideoFormData"
                    :on-remove="videoHandleRemove"
                    :on-progress="videoHandleProgress"
                    :on-success="videoUploadSuccess"
                    :before-upload="videoUpload"
                    :on-change="videoHandleChange"
                    :on-exceed="videoHandleExceed"
                    list-type="picture"
                    :file-list="videoList"
                    :limit="1"
                    :show-file-list="true"
                    :auto-upload="false"
                    accept="video/mp4,video/webm"
                >
                  <img src="../../assets/images/sping.png" :style="videoList.length > 0 ? 'margin-top: 15px' : ''"/>
                  <div v-if="videoList.length === 0">添加视频</div>
                  <div v-if="videoList.length > 0" class="rwa_publish_info_0131_sc" @click.stop="videoSubmitUpload">上传视频</div>
                </el-upload>

              </div>

              <div class="rwa_publish_info_02">
                <div class="rwa_publish_info_021">标题</div>
                <el-input
                    class="rwa_publish_info_022"
                    placeholder="请输入拍卖商品标题"
                    v-model="titleValue"
                    clearable>
                </el-input>
              </div>

              <div class="rwa_publish_info_03">
                <div class="rwa_publish_info_031">
                  <div class="rwa_publish_info_0311">起拍价 (BNB)</div>
                  <el-input
                      class="rwa_publish_info_0312"
                      placeholder="请输入起拍价"
                      v-model="startPriceValue"
                      clearable>
                  </el-input>
                </div>
                <div class="rwa_publish_info_032">
                  <div class="rwa_publish_info_0321">评估价 (BNB)</div>
                  <el-input
                      class="rwa_publish_info_0322"
                      placeholder="请输入评估价"
                      v-model="estimatePriceValue"
                      clearable>
                  </el-input>
                </div>
              </div>

              <div class="rwa_publish_info_02">
                <div class="rwa_publish_info_021">加价幅度 (BNB)</div>
                <el-input
                    class="rwa_publish_info_022"
                    placeholder="请输入拍卖加价幅度"
                    v-model="priceIncreaseValue"
                    clearable>
                </el-input>
              </div>

              <div class="rwa_publish_info_04">
                <div class="rwa_publish_info_041">
                  <div class="rwa_publish_info_0411">开拍时间</div>
                  <el-date-picker
                      class="rwa_publish_info_0412"
                      :key="startPickerKey"
                      :append-to-body="false"
                      v-model="startDateValue"
                      type="datetime"
                      placeholder="选择开拍时间">
                  </el-date-picker>
                </div>
                <div class="rwa_publish_info_042">
                  <div class="rwa_publish_info_0421">结束时间</div>
                  <el-date-picker
                      class="rwa_publish_info_0422"
                      :key="endPickerKey"
                      :append-to-body="false"
                      v-model="endDateValue"
                      type="datetime"
                      placeholder="选择结束时间">
                  </el-date-picker>
                </div>
              </div>

              <div class="rwa_publish_info_05">
                <div class="rwa_publish_info_051">商品详情</div>
                <quill-editor
                    class="rwa_publish_info_052"
                    v-model="content"
                    :options="editorOptions"
                />
              </div>

              <div v-if="!isAddProjectInfo" class="rwa_publish_info_06" @click="onChainProject()">数据上链</div>
              <div v-if="isAddProjectInfo" class="rwa_publish_info_06" @click="toPublish()">确认发布</div>
            </div>
          </div>
        </div>
      </div>

      <div class="rwa_publish_page_03">
        <Bottom/>
      </div>
    </div>

  </div>
</template>

<script>
import {
  cutAccount,
  lang,
  BigNumber,
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub
} from '../../tools/index';

import transfer from "../../tools/transfer";
import Menu from "../../components/Menu";
import Bottom from "../../components/Bottom";
import * as metaMaskTools from "../../tools/chain";

import {
  debug,
  uploadHost
} from "@/config";

import { mixin1 } from "@/tools/mixins";

import axios from 'axios';
import { setDecimal } from "@/tools/toolUtils";

// 导入 Quill 编辑器
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: "Publish",
  components: { Menu, Bottom, quillEditor },
  mixins: [mixin1],
  data() {
    return {
      isAddProjectInfo: false,
      addProjectId: null,
      imgHost: uploadHost,
      logoAddNum: 0,
      logoList: [],
      logoImage: null,
      uploadLogoFormData: {
        file_type: 'image',
        group_number: 1
      },
      certificateAddNum: 0,
      certificateList: [],
      certificateImage: null,
      uploadCertificateFormData: {
        file_type: 'image',
        group_number: 3
      },
      videoAddNum: 0,
      videoList: [],
      videoUrl: null, // 用于存储上传的视频URL
      uploadVideoFormData: {
        file_type: 'video'
      },
      indexBlockNum: 0,
      titleValue: null,
      priceIncreaseValue: null,
      startPriceValue: null,
      estimatePriceValue: null,
      startPickerKey: 'startPicker_' + new Date(),
      endPickerKey: 'endPicker_' + new Date(),
      startDateValue: new Date(),
      endDateValue: new Date(),
      content: '', // 富文本内容
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],    // 加粗、斜体、下划线、删除线
            ['blockquote', 'code-block'],                 // 引用、代码块
            [{ 'header': 1 }, { 'header': 2 }],           // 标题1、标题2
            [{ 'list': 'ordered'}, { 'list': 'bullet' }], // 有序列表、无序列表
            [{ 'script': 'sub'}, { 'script': 'super' }],  // 下标、上标
            [{ 'indent': '-1'}, { 'indent': '+1' }],      // 缩进
            [{ 'direction': 'rtl' }],                     // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],    // 标题级别
            [{ 'color': [] }, { 'background': [] }],      // 字体颜色、背景色
            [{ 'font': [] }],                             // 字体
            [{ 'align': [] }],                            // 对齐方式
            ['clean'],                                     // 清除格式
            ['link', 'image', 'video']                    // 链接、图片、视频
          ]
        },
        placeholder: '请输入商品详情...',
        theme: 'snow'  // 或 'bubble'
      }
    };
  },
  created() {
    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);

    transfer.$on("initPublishPageData", () => {
      this.initPublishPageData();
    });
  },
  mounted() {
    this.getNextProjectId();
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    lang(key){
      return lang(key);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initPublishPageData();
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    initPublishPageData() {
    },
    async getNextProjectId() {
      try {
        await metaMaskTools.nextProjectId().then(async (data) => {
          this.addProjectId = parseInt(data);

          console.log("nextProjectId: " + this.addProjectId);
        }).catch(err => {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    toIndex() {
      transfer.$emit("toMenuPage", 1);
    },



    // 文件列表移除文件时的钩子
    logoHandleRemove(file, fileList) {
      console.log(file, fileList);

      this.logoList = fileList;

      console.log("logoList: " + this.logoList);
    },
    // 文件上传时的钩子
    logoHandleProgress(event, file, fileList) {
      console.log(event, file, fileList);
    },
    // 文件状态改变时的钩子
    logoHandleChange(file, fileList) {
      console.log("logoHandleChange", file, fileList);

      this.logoList = fileList;

      console.log("logoList: " + this.logoList);
    },
    // 上传Logo前的校验
    logoUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error('上传Logo图片大小不能超过10MB!');
        return false;
      }

      return isLt10M;
    },
    // 上传
    logoSubmitUpload() {
      if (!this.isAddProjectInfo) {
        this.$message.warning('请先将数据上链成功后再上传Logo!');
        return;
      }
      console.log("上传Logo！");

      this.$refs.uploadLogo.submit();
    },
    // 上传Logo成功处理
    logoUploadSuccess(response, file) {
      this.logoAddNum += 1;

      if (this.logoAddNum === 1) {
        this.uploadLogoFormData.group_number = 2;
      }

      this.$message.success('Logo上传成功!');
    },



    // 文件列表移除文件时的钩子
    certificateHandleRemove(file, fileList) {
      console.log(file, fileList);

      this.certificateList = fileList;

      console.log("certificateList: " + this.certificateList);
    },
    // 文件上传时的钩子
    certificateHandleProgress(event, file, fileList) {
      console.log(event, file, fileList);
    },
    // 文件状态改变时的钩子
    certificateHandleChange(file, fileList) {
      console.log("certificateHandleChange", file, fileList);

      this.certificateList = fileList;

      console.log("certificateList: " + this.certificateList);
    },
    // 上传证书前的校验
    certificateUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error('上传证书图片大小不能超过10MB!');
        return false;
      }

      return isLt10M;
    },
    // 上传
    certificateSubmitUpload() {
      if (!this.isAddProjectInfo) {
        this.$message.warning('请先将数据上链成功后再上传证书!');
        return;
      }
      console.log("上传证书！");

      this.$refs.uploadCertificate.submit();
    },
    // 上传证书成功处理
    certificateUploadSuccess(response, file) {
      this.certificateAddNum += 1;

      this.$message.success('证书上传成功!');
    },



    // 文件列表移除文件时的钩子
    videoHandleRemove(file, fileList) {
      console.log(file, fileList);

      this.videoList = fileList;

      console.log("videoList: " + this.videoList);
    },
    // 文件上传时的钩子
    videoHandleProgress(event, file, fileList) {
      console.log(event, file, fileList);
    },
    // 文件状态改变时的钩子
    videoHandleChange(file, fileList) {
      console.log("videoHandleChange", file, fileList);

      this.videoList = fileList;

      console.log("videoList: " + this.videoList);
    },
    // 文件超出个数限制时的钩子
    videoHandleExceed(files, fileList) {
      console.log(files, fileList);

      this.$message.error('最多只能上传一条视频!');
      return false;
    },
    // 上传视频前的校验
    videoUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 80;

      if (!isLt100M) {
        this.$message.error('上传视频大小不能超过80MB!');
        return false;
      }

      const validTypes = ['video/mp4', 'video/webm'];
      if (!validTypes.includes(file.type)) {
        this.$message.error('只支持mp4/webm格式的视频!');
        return false;
      }

      return true;
    },
    // 上传
    videoSubmitUpload() {
      if (!this.isAddProjectInfo) {
        this.$message.warning('请先将数据上链成功后再上传视频!');
        return;
      }
      console.log("上传视频！");

      this.$refs.uploadVideo.submit();
    },
    // 上传视频成功处理
    videoUploadSuccess(response, file) {
      this.videoAddNum += 1;

      this.$message.success('视频上传成功!');
    },



    // 上链
    async onChainProject() {
      try {
        if (this.startPriceValue <= 0) {
          this.$message.warning('起拍价不能小于等于0!');
          return;
        }
        if (this.estimatePriceValue <= 0) {
          this.$message.warning('评估价不能小于等于0!');
          return;
        }

        if (this.startDateValue >= this.endDateValue) {
          this.$message.warning('开始时间不能大于或者等于结束时间!');
          return;
        }

        if (!(this.priceIncreaseValue && parseFloat(this.priceIncreaseValue) > 0)) {
          this.$message.warning('加价幅度不能小于等于0!');
          return;
        }

        // 获取区块
        await metaMaskTools.getIndexBlock().then(async (data) => {
          this.$message.success('拍卖信息开始上链: (BlockNumber: ' + data + ')');

          if (data) {
            this.indexBlockNum = parseInt(data) - 1000;

            // 创建项目
            await metaMaskTools.createProject([
              BigNumberMul(this.startPriceValue, 1e18),
              parseInt((this.startDateValue.getTime() / 1000).toString()),
              parseInt((this.endDateValue.getTime() / 1000).toString()),
              BigNumberMul(this.priceIncreaseValue, 1e18),
              BigNumberMul(this.estimatePriceValue, 1e18)
            ]).then(async (data) => {
              this.$message.success('上链成功，开始验证上链数据, 请稍等!');

              // setTimeout(async() => {
              //   this.isAddProjectInfo = true;
              //
              //   this.$message.success('拍卖信息上链成功，请继续将拍卖数据发布到服务器!');
              // }, 1000);

              // 验证拍卖信息是否上链
              setTimeout(async() => {
                await this.confirmOnChain();
              }, 1000);
            }).catch(err => {
              console.log(err);
            });
          } else {
            this.$message.error('网络错误，请重试!');
          }
        }).catch(err => {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 验证拍卖信息是否上链
     * @returns {Promise<void>}
     */
    async confirmOnChain(retryCount = 0) {
      try {
        if (this.indexBlockNum >= 65000000) {
          await metaMaskTools.getFilteredEvents(this.addProjectId, this.indexBlockNum).then(async (data) => {
            if (data && data.length > 0) {
              console.log("getFilteredEvents: " + JSON.stringify(data));

              if (parseInt(this.addProjectId) === parseInt(data[0].returnValues.projectId)) {
                this.isAddProjectInfo = true;

                this.$message.success('拍卖信息上链成功，请继续将拍卖数据发布到服务器!');
              } else {
                // 如果验证失败且重试次数小于3次，则3秒后重试
                if (retryCount < 2) {
                  this.$message.warning(`验证失败，第${retryCount + 1}次重试中...`);
                  setTimeout(() => {
                    this.confirmOnChain(retryCount + 1);
                  }, 3000);
                } else {
                  this.$message.error('验证失败，已达到最大重试次数!');
                }
              }
            } else {
              // 如果没有获取到数据且重试次数小于3次，则3秒后重试
              if (retryCount < 2) {
                this.$message.warning(`未获取到数据，第${retryCount + 1}次重试中...`);
                setTimeout(() => {
                  this.confirmOnChain(retryCount + 1);
                }, 3000);
              } else {
                this.$message.error('网络错误，已达到最大重试次数!');
              }
            }
          }).catch(err => {
            console.log(err);
            // 如果出错且重试次数小于3次，则3秒后重试
            if (retryCount < 2) {
              this.$message.warning(`查询出错，第${retryCount + 1}次重试中...`);
              setTimeout(() => {
                this.confirmOnChain(retryCount + 1);
              }, 3000);
            } else {
              this.$message.error('查询出错，已达到最大重试次数!');
            }
          });
        } else {
          this.$message.error('错误操作，请先将拍卖信息上链!');
        }
      } catch (e) {
        console.log(e);
        // 如果捕获到异常且重试次数小于3次，则3秒后重试
        if (retryCount < 2) {
          this.$message.warning(`服务异常，第${retryCount + 1}次重试中...`);
          setTimeout(() => {
            this.confirmOnChain(retryCount + 1);
          }, 3000);
        } else {
          this.$message.error('服务异常，已达到最大重试次数!');
        }
      }
    },
    // 提交服务器
    async toPublish() {
      try {
        if (this.isAddProjectInfo) {
          if (this.logoAddNum <= 0) {
            this.$message.warning("请先上传Logo!");
            return;
          }
          if (this.certificateAddNum <= 0) {
            this.$message.warning("请先上传证书!");
            return;
          }
          if (this.videoAddNum <= 0) {
            this.$message.warning("请先上传视频!");
            return;
          }

          if (
              this.titleValue === null ||
              this.titleValue === '' ||
              this.titleValue === undefined ||
              this.titleValue === 'null' ||
              this.titleValue.length > 200
          ) {
            this.$message.warning("标题格式错误!");
            return;
          }

          if (
              this.content === null ||
              this.content === '' ||
              this.content === undefined ||
              this.content === 'null' ||
              this.content.length > 2000
          ) {
            this.$message.warning("商品详情格式错误!");
            return;
          }

          this.$http.createProjectInfo(this.addProjectId, this.titleValue, this.content).then(res => {
            console.log("createProjectInfo: " + JSON.stringify(res));

            if (res.success) {
              this.$message.success('拍卖信息发布成功，请返回列表查看!');

              // 重置信息
              this.resetInformation();
            } else {
              this.$message.warning('服务错误!');
            }
          }).catch(err => {
            console.log(err);
          });
        } else {
          this.$message.warning("请先将拍卖信息上链!");
        }
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 重置拍卖信息
     * @returns {Promise<void>}
     */
    async resetInformation() {
      this.isAddProjectInfo = false;

      this.titleValue = null;
      this.startPriceValue = null;
      this.estimatePriceValue = null;
      this.startPickerKey = 'startPicker_' + new Date();
      this.endPickerKey = 'endPicker_' + new Date();
      this.startDateValue = new Date();
      this.endDateValue = new Date();
      this.content = ''; // 富文本内容

      await this.getNextProjectId();

      this.$refs.uploadLogo.clearFiles();
      this.$refs.uploadCertificate.clearFiles();
      this.$refs.uploadVideo.clearFiles();
    }
  }
};
</script>

<style scoped lang="less">
.rwa_publish_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .rwa_publish_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .rwa_publish_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .rwa_publish_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_publish_page_021 {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: flex-start;
      position: relative;
      .rwa_publish_page_021s {
        z-index: 1;
        margin-bottom: 100px;
        width: 70%;
        min-height: 700px;

        @media (max-width: 767px) {
          width: 90%;
        }
        .rwa_publish_page_0211 {
          z-index: 1;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          margin: 60px 0 20px 0;
          cursor: pointer;
          img {
            width: 25px;
            margin-right: 20px;
          }
          div {
            color: #FFF;
            font-family: Montserrat;
            font-size: 26px;
            font-style: italic;
            font-weight: 900;
            line-height: 152%; /* 39.52px */
          }
        }
        .rwa_publish_page_0212s {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: nowrap;
          .rwa_publish_page_0212 {
            width: 768px;
            //height: 887px;
            flex-shrink: 0;
            border-radius: 12px;
            background: #313131;
            padding: 20px;

            @media (max-width: 767px) {
              width: 100%;
            }
            .rwa_publish_info_title {
              color: #E5E7EB;
              text-align: center;
              font-family: Roboto;
              font-size: 24px;
              font-style: normal;
              font-weight: 700;
              line-height: 32px; /* 133.333% */
              margin: 15px 0 30px 0;
            }
            .rwa_publish_info_01 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: flex-start;
              justify-content: space-between;
              margin-bottom: 25px;

              @media (max-width: 767px) {
                flex-wrap: wrap;
                align-content: flex-start;
              }
              .rwa_publish_info_011 {
                width: 128px;
                height: auto;
                min-height: 128px;
                flex-shrink: 0;
                border-radius: 12px;
                border: 2px dashed rgba(153, 153, 153, 0.20);
                background: #363636;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                img {
                  width: 15px;
                  margin-bottom: 5px;
                }
                div {
                  color: #E5E7EB;
                  font-size: 15px;
                }
                .rwa_publish_info_0111_sc {
                  width: 100px;
                  height: 35px;
                  line-height: 35px;
                  flex-shrink: 0;
                  border-radius: 4px;
                  background: #20944B;
                  color: #FFF;
                  text-align: center;
                  font-family: Roboto;
                  font-style: normal;
                  margin-top: 10px;
                  margin-bottom: 5px;
                  cursor: pointer;
                }
                .rwa_publish_info_0111 {
                  font-size: 12px;
                  color: #888888;
                }
              }
              .rwa_publish_info_012 {
                width: 272px;
                height: auto;
                min-height: 128px;
                flex-shrink: 0;
                border-radius: 4px;
                border: 1px solid rgba(153, 153, 153, 0.20);
                background: #363636;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                img {
                  width: 15px;
                  margin-bottom: 5px;
                }
                div {
                  color: #E5E7EB;
                  font-size: 15px;
                }
                .rwa_publish_info_0121_sc {
                  width: 100px;
                  height: 35px;
                  line-height: 35px;
                  flex-shrink: 0;
                  border-radius: 4px;
                  background: #20944B;
                  color: #FFF;
                  text-align: center;
                  font-family: Roboto;
                  font-style: normal;
                  margin-top: 10px;
                  margin-bottom: 5px;
                  cursor: pointer;
                }
              }
              .rwa_publish_info_013 {
                width: 272px;
                height: auto;
                min-height: 128px;
                flex-shrink: 0;
                border-radius: 4px;
                border: 1px solid rgba(153, 153, 153, 0.20);
                background: #363636;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                @media (max-width: 767px) {
                  width: 100%;
                  margin-top: 20px;
                }
                img {
                  width: 30px;
                  margin-bottom: 2px;
                }
                div {
                  color: #E5E7EB;
                  font-size: 15px;
                }
                .rwa_publish_info_0131_sc {
                  width: 100px;
                  height: 35px;
                  line-height: 35px;
                  flex-shrink: 0;
                  border-radius: 4px;
                  background: #20944B;
                  color: #FFF;
                  text-align: center;
                  font-family: Roboto;
                  font-style: normal;
                  margin-top: 10px;
                  margin-bottom: 5px;
                  cursor: pointer;
                }
              }
            }
            .rwa_publish_info_02 {
              margin-bottom: 25px;
              .rwa_publish_info_021 {
                color: #E5E7EB;
                font-family: Roboto;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 20px; /* 142.857% */
                margin-bottom: 10px;
              }
              .rwa_publish_info_022 {

              }
            }
            .rwa_publish_info_03 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 25px;
              .rwa_publish_info_031 {
                width: 49%;
                .rwa_publish_info_0311 {
                  color: #E5E7EB;
                  font-family: Roboto;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 20px; /* 142.857% */
                  margin-bottom: 10px;
                }
                .rwa_publish_info_0312 {

                }
              }
              .rwa_publish_info_032 {
                width: 49%;
                .rwa_publish_info_0321 {
                  color: #E5E7EB;
                  font-family: Roboto;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 20px; /* 142.857% */
                  margin-bottom: 10px;
                }
                .rwa_publish_info_0322 {

                }
              }
            }
            .rwa_publish_info_04 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 25px;
              .rwa_publish_info_041 {
                width: 49%;
                .rwa_publish_info_0411 {
                  color: #E5E7EB;
                  font-family: Roboto;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 20px; /* 142.857% */
                  margin-bottom: 10px;
                }
                .rwa_publish_info_0412 {

                }
              }
              .rwa_publish_info_042 {
                width: 49%;
                .rwa_publish_info_0421 {
                  color: #E5E7EB;
                  font-family: Roboto;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 20px; /* 142.857% */
                  margin-bottom: 10px;
                }
                .rwa_publish_info_0422 {

                }
              }
            }
            .rwa_publish_info_05 {
              margin-bottom: 35px;
              .rwa_publish_info_051 {
                color: #E5E7EB;
                font-family: Roboto;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 20px; /* 142.857% */
                margin-bottom: 10px;
              }
              .rwa_publish_info_052 {
                width: 724px;
                height: 350px;
                flex-shrink: 0;
                border-radius: 12px;
                border: 1px solid rgba(153, 153, 153, 0.20) !important;
                background: #363636 !important;

                @media (max-width: 767px) {
                  width: 100%;
                  height: 580px;
                }

                /* 覆盖 Quill 编辑器内部样式 */
                /deep/ .ql-container {
                  border: none !important;
                  background: transparent !important;
                  height: 283px !important;
                }
                /deep/ .ql-toolbar {
                  border: none !important;
                  background: #d0d0d0 !important;
                  border-top-left-radius: 12px !important;
                  border-top-right-radius: 12px !important;
                }
                /deep/ .ql-editor::-webkit-scrollbar {
                  width: 0;
                  height: 0;
                }
                /deep/ .ql-editor {
                  overflow-y: auto;
                  color: #E5E7EB;
                  min-height: 120px;
                }
              }
            }
            .rwa_publish_info_06 {
              width: 128px;
              height: 46px;
              line-height: 46px;
              flex-shrink: 0;
              border-radius: 4px;
              background: #20944B;
              color: #FFF;
              text-align: center;
              font-family: Roboto;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              margin-left: calc(50% - 64px);
              margin-bottom: 20px;
              cursor: pointer;
            }
          }
        }
      }
      .rwa_publish_page_021_bj01 {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        height: 100%;
        max-height: 880px;
        @media (max-width: 767px) {
          max-height: 720px;
        }
      }
      .rwa_publish_page_021_bj03 {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 0;
        max-width: 60%;
        @media (max-width: 767px) {
          max-width: 45%;
          display: none;
        }
      }
    }
    .rwa_publish_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_publish_div {
  .video-preview {
    max-width: 272px;
    max-height: 100px;
    object-fit: contain;
    background: #000;
  }

  .el-input__inner {
    border-radius: 4px !important;
    border: 1px solid rgba(153, 153, 153, 0.20) !important;
    background: #363636 !important;
    color: #cbcbcb !important;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: -webkit-fill-available !important;
  }
  .el-picker-panel {
    color: #606266;
    border: 1px solid #595959;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: #2c2c2c;
  }
  .el-picker-panel__footer {
    border-top: 1px solid #545454;
    background-color: #292929;
  }
  .el-button--default:hover {
    background: #2c2c2c !important;
  }
  .el-button--default {
    background: #20944B;
    border: 1px solid #20944B;
    border-color: #20944B;
    color: #DCDFE6;
  }
  .el-date-picker__time-header {
    border-bottom: 1px solid #545454;
  }
  .el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #545454;
  }
  .el-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #2c2c2c;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
  }

  .el-popper[x-placement^=top] .popper__arrow::after {
    border-top-color: #2b2b2b;
  }

  .el-upload-list {
    width: 100% !important;
  }

  .el-message {
    z-index: 3000 !important;
  }
}
</style>